import type { ChangelogEntry } from "../types";

/** VIB-2870: klikk på en måned i prognosen viser prosjektene bak tallet. */
export const PROGNOSE_GRUNNLAG_2026_10: ChangelogEntry = {
  id: "2026-10-12-prognose-grunnlag",
  date: "2026-10-12",
  title: "Se hvilke prosjekter som ligger bak prognosen",
  summary:
    "Klikk på en søyle i prognose-widgeten på Måltall for å se prosjektene bak tallet, med fakturert, estimert rest og sluttdato per prosjekt.",
  sections: [
    {
      heading: "Måltall",
      minRole: "admin",
      items: [
        {
          title: "Klikk på en måned for å se grunnlaget",
          kind: "nytt",
          body: "Hver søyle i prognosen kan klikkes. Da åpner en liste over prosjektene som er med i måneden, med fakturert beløp, estimert rest, sum og sluttdato per prosjekt. Summen nederst er den samme som i tooltipen på søylen. Prosjektnavnet tar deg rett til prosjektets fakturaside, så du kan følge opp et tall som ser feil ut.",
        },
        {
          title: "Forfalte prosjekter er merket",
          kind: "nytt",
          body: "Prosjekter som har passert sluttdato uten å være ferdig fakturert, flyttes til inneværende måned i prognosen. I listen er de merket «Forfalt, flyttet hit», så du ser hvorfor måneden ser stor ut og kan sette ny sluttdato.",
        },
      ],
    },
  ],
};
